// masterSchedule.ts — done-state for the curated master-schedule timeline.

import { request } from './request'

export const masterScheduleApi = {
  // `groundbreak` (actual ?? target) rides along so a caller can forecast the
  // curated timeline without a second, heavier schedule fetch.
  progress: (projectId: string) =>
    request<{ ok: true; completed: string[]; groundbreak: string | null }>(
      `/api/projects/${encodeURIComponent(projectId)}/master-schedule/progress`,
    ),
  setDone: (projectId: string, taskKey: string, completed: boolean) =>
    request<{ ok: true; task_key: string; completed: boolean }>(
      `/api/projects/${encodeURIComponent(projectId)}/master-schedule/progress`,
      { method: 'POST', body: JSON.stringify({ task_key: taskKey, completed }) },
    ),
}
